<template>
  <AeAuthentication :store="store">
    <template #profile>
      <router-link to="/profile" class="ae-profile-link">
        <span class="ae-profile-link__icon">👤</span>
        {{ t('authComponent.profileAndPreferences') }}
      </router-link>
    </template>
  </AeAuthentication>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { AeAuthentication } from '@aevue/components'
import { useAppStore } from '../stores/app.js'

const { t } = useI18n()
const store = useAppStore()
</script>

<style scoped>
.ae-profile-link {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  color: var(--text-color, #2d3748);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.ae-profile-link:hover {
  background-color: var(--button-hover-bg, rgba(255, 255, 255, 0.65));
}

.ae-profile-link__icon {
  opacity: 0.7;
  font-size: 16px;
}
</style>

